module.exports = __webpack_public_path__ + "img/zoo.67997528.png";